import React from 'react';
import useWeb3 from '../../../../../../../contexts/web3';
import useUserData from '../../../../../../../contexts/userData';
import Button from '../../../../../../controls/button';
import usePromo from '../../../../../marketPage/promoCode/Context';
import { useNavigate } from 'react-router-dom';

interface Props {
  className: string;
  token?: string;
}

const LandingMintSectionMintButton = ({ className, token }: Props) => {
  const navigate = useNavigate();
  const { appliedCode } = usePromo();
  const { handleMetamaskClick } = useWeb3();
  const { login, loginLoading, loggedIn } = useUserData();

  const handleClick = () => {
    const url = ['/market'];
    if (token) {
      url.push(`?id=${token}&mint=1`);
      if (appliedCode) {
        url.push(`&code=${appliedCode.code}`);
      }
    }
    if (loggedIn) {
      navigate(url.join(''));
    } else {
      handleMetamaskClick(() => login(url.join('')), 'login/signup');
    }
  };

  return (
    <Button className={className} onClick={handleClick} loading={loginLoading}>
      Mint Now
    </Button>
  );
};

export default LandingMintSectionMintButton;
